export const slashPathIndex: Record<string, Record<string, string>> = {
  'deziiign/mediiia': {
    creative: 'deziiign/creativemediiia',
    history: 'deziiign/historymediiia',
    transfer: 'deziiign/transfermediiia', // TODO: [МУСОР] убрать?
    profi: 'deziiign/profmediiia',
    work: 'deziiign/profmediiia',
    sport: 'deziiign/sportmediiia',
    sound: 'deziiign/musicmediiia',
    stories: 'deziiign/storiesmediiia',
    astro: 'deziiign/naturemediiia',
    art: 'deziiign/artmediiia',
    fair: 'deziiign/fairmediiia',
    artfair: 'deziiign/fairmediiia',
    kiiids: 'deziiign/kiiidsmediiia',
    design: 'deziiign/designmediiia',
    urban: 'deziiign/urbanmediiia',
    cine: 'deziiign/cinemediiia',
    ai: 'deziiign/aimediiia',
    fashion: 'deziiign/fashionmediiia',
    food: 'deziiign/foodmediiia',
    auto: 'deziiign/automediiia',
    '365': 'deziiign/eventmediiia',
    mediiiabooks: 'deziiign/booksmediiia',
    books: 'deziiign/booksmediiia',
    concept: 'deziiign/conceptmediiia',
    advert: 'deziiign/admediiia',
    my: 'deziiign/mymediiia'
  },
  'deziiign/iqmedia': {
    lk: 'deziiign/iqmedia',
  },
  'deziiign/hsespace': {
    architect: 'deziiign/s-architect',
    oriental: 'deziiign/s-oriental',
    geography: 'deziiign/s-geography',
    digital: 'deziiign/s-digital',
    hseincomm: 'deziiign/s-hseincomm',
    // design: 'deziiign/design',
    history: 'deziiign/s-history',
    arthistory: 'deziiign/s-arthistory',
    cinema: 'deziiign/s-cinema',
    cognitive: 'deziiign/s-cognitive',
    culturology: 'deziiign/s-culturology',
    mathematics: 'deziiign/s-mathematics',
    media: 'deziiign/s-media',
    fashion: 'deziiign/s-fashion',
    music: 'deziiign/s-music',
    production: 'deziiign/s-production',
    hsetto: 'deziiign/s-hsetto',
    pro: 'deziiign/s-pro',
    psychology: 'deziiign/s-psychology',
    physics: 'deziiign/s-physics',
    chemistry: 'deziiign/s-chemistry',
    economy: 'deziiign/s-economy',
    'public-administration': 'deziiign/s-public-administration',
    'urban-development': 'deziiign/s-urban-development',
    'computer-science-and-engineering': 'deziiign/s-computer-science-and-engineering',
    'international-relations': 'deziiign/s-international-relations',
    'management': 'deziiign/s-management',
    'political-science': 'deziiign/s-political-science',
    'advertising-and-pr': 'deziiign/s-advertising-and-pr',
    'sociology': 'deziiign/s-sociology',
    'philology': 'deziiign/s-philology',
    'philosophy': 'deziiign/s-philosophy',
    'jurisprudence': 'deziiign/s-jurisprudence',
    'mediadepartment': 'deziiign/s-mediadepartment',
    'software-engineering': 'deziiign/s-software-engineering',
    hseissek: 'deziiign/s-hseissek',
    creative: 'deziiign/hsespacecreative',
    hsecreativehub: 'deziiign/hsecreativehub',
    film: 'deziiign/hsespacefilm',
    virtualspace: 'deziiign/s-virtualspace',
    extra: 'deziiign/s-extra'
  },
  'deziiign/main': {
    awards: 'competition',
    fr: 'fr/main',
  },
  'kz/dafes': {
    art: 'kz/dafes-art',
    fashion: 'kz/dafes-fashion',
  },
}

export const enginePaths = Object.values(slashPathIndex).reduce((acc, paths) => {
  const slashApps = Object.values(paths).reduce((acc, path) => ({
    ...acc,
    [path]:  true
  }), {})
  return ({
    ...acc,
    ...slashApps,
  })
}, {})

const getSlashContexts = (path: string): string[] => {
  return Object.values(slashPathIndex[path]).reduce((acc: string[], path) => {
    return [
      ...acc,
      path
    ]
  }, [])
}

//todo разнести по папкам
export const MEDIIIA_CONTEXTS = ['deziiign/mediiia', ...getSlashContexts('deziiign/mediiia')]
export const HSESPACE_CONTEXTS = ['deziiign/hsespace', ...getSlashContexts('deziiign/hsespace')]
export const DEZIIIGN_CONTEXTS = [
  'deziiign/main',
  'deziiign/books',
  'deziiign/pro',
  'deziiign/fashion',
  'deziiign/game',
  'deziiign/urbanmediiia',
  'deziiign/lab',
  'competition',
   ...getSlashContexts('deziiign/main')]
export const slashPathIndex: Record<string, Record<string, string>> = {
  'deziiign/mediiia': {
    creative: 'deziiign/creativemediiia',
    history: 'deziiign/historymediiia',
    transfer: 'deziiign/transfermediiia', // TODO: [МУСОР] убрать?
    profi: 'deziiign/profmediiia',
    work: 'deziiign/profmediiia',
    sport: 'deziiign/sportmediiia',
    sound: 'deziiign/musicmediiia',
    stories: 'deziiign/storiesmediiia',
    astro: 'deziiign/naturemediiia',
    art: 'deziiign/artmediiia',
    fair: 'deziiign/fairmediiia',
    artfair: 'deziiign/fairmediiia',
    kiiids: 'deziiign/kiiidsmediiia',
    design: 'deziiign/designmediiia',
    urban: 'deziiign/urbanmediiia',
    cine: 'deziiign/cinemediiia',
    ai: 'deziiign/aimediiia',
    fashion: 'deziiign/fashionmediiia',
    food: 'deziiign/foodmediiia',
    auto: 'deziiign/automediiia',
    '365': 'deziiign/eventmediiia',
    mediiiabooks: 'deziiign/booksmediiia',
    books: 'deziiign/booksmediiia',
    concept: 'deziiign/conceptmediiia',
    advert: 'deziiign/admediiia',
    my: 'deziiign/mymediiia'
  },
  'deziiign/iqmedia': {
    lk: 'deziiign/iqmedia',
  },
  'deziiign/hsespace': {
    architect: 'deziiign/s-architect',
    oriental: 'deziiign/s-oriental',
    geography: 'deziiign/s-geography',
    digital: 'deziiign/s-digital',
    hseincomm: 'deziiign/s-hseincomm',
    // design: 'deziiign/design',
    history: 'deziiign/s-history',
    arthistory: 'deziiign/s-arthistory',
    cinema: 'deziiign/s-cinema',
    cognitive: 'deziiign/s-cognitive',
    culturology: 'deziiign/s-culturology',
    mathematics: 'deziiign/s-mathematics',
    media: 'deziiign/s-media',
    fashion: 'deziiign/s-fashion',
    music: 'deziiign/s-music',
    production: 'deziiign/s-production',
    hsetto: 'deziiign/s-hsetto',
    pro: 'deziiign/s-pro',
    psychology: 'deziiign/s-psychology',
    physics: 'deziiign/s-physics',
    chemistry: 'deziiign/s-chemistry',
    economy: 'deziiign/s-economy',
    'public-administration': 'deziiign/s-public-administration',
    'urban-development': 'deziiign/s-urban-development',
    'computer-science-and-engineering': 'deziiign/s-computer-science-and-engineering',
    'international-relations': 'deziiign/s-international-relations',
    'management': 'deziiign/s-management',
    'political-science': 'deziiign/s-political-science',
    'advertising-and-pr': 'deziiign/s-advertising-and-pr',
    'sociology': 'deziiign/s-sociology',
    'philology': 'deziiign/s-philology',
    'philosophy': 'deziiign/s-philosophy',
    'jurisprudence': 'deziiign/s-jurisprudence',
    'mediadepartment': 'deziiign/s-mediadepartment',
    'software-engineering': 'deziiign/s-software-engineering',
    hseissek: 'deziiign/s-hseissek',
    creative: 'deziiign/hsespacecreative',
    hsecreativehub: 'deziiign/hsecreativehub',
    film: 'deziiign/hsespacefilm',
    virtualspace: 'deziiign/s-virtualspace',
    extra: 'deziiign/s-extra'
  },
  'deziiign/main': {
    awards: 'competition',
    fr: 'fr/main',
  },
  'kz/dafes': {
    art: 'kz/dafes-art',
    fashion: 'kz/dafes-fashion',
  },
}

export const enginePaths = Object.values(slashPathIndex).reduce((acc, paths) => {
  const slashApps = Object.values(paths).reduce((acc, path) => ({
    ...acc,
    [path]:  true
  }), {})
  return ({
    ...acc,
    ...slashApps,
  })
}, {})

const getSlashContexts = (path: string): string[] => {
  return Object.values(slashPathIndex[path]).reduce((acc: string[], path) => {
    return [
      ...acc,
      path
    ]
  }, [])
}

//todo разнести по папкам
export const MEDIIIA_CONTEXTS = ['deziiign/mediiia', ...getSlashContexts('deziiign/mediiia')]
export const HSESPACE_CONTEXTS = ['deziiign/hsespace', ...getSlashContexts('deziiign/hsespace')]
export const DEZIIIGN_CONTEXTS = [
  'deziiign/main',
  'deziiign/books',
  'deziiign/pro',
  'deziiign/fashion',
  'deziiign/game',
  'deziiign/urbanmediiia',
  'deziiign/lab',
  'competition',
   ...getSlashContexts('deziiign/main')]
